export default "__VITE_ASSET__53b65865__"